<template>
  <div>
    <page-header :header="country.name" />

    <country-form
      v-if="country"
      ref="form"
      class="mt-4"
      :draft="country.draft"
      @save="onSave"
      @cancel="onCancel"
      @publish="onPublish"
    />

    <div class="d-flex justify-content-between mb-4">
      <button class="btn btn-outline-primary" @click="$refs.form.cancel()">Cancel</button>
      <button
        class="btn btn-outline-primary"
        @click="$refs.form.save()"
      >Save Draft</button>
      <button
        class="btn btn-primary"
        @click="$refs.form.publish()"
      >Publish</button>
    </div>
  </div>
</template>

<script>
import {Vue, Component} from 'nuxt-property-decorator'
import gateway from '@/gateway'
import {debounce} from '@/helpers'
import { successNotification, warningNotification } from '@/notifications'
import CountryForm from './components/Form'

@Component({
  components: {
    CountryForm,
  },
})
export default class CountriesListView extends Vue {

  country = { name: '', draft: {} }

  delayedSave() {
    const vm = this
    return debounce(async function () {
      await vm.saveDraft()
    }, 10)()
  }

  async created () {
    try {
      const [countryResponse] = await Promise.all([
        gateway.get(`cms/engage/country/${this.$route.params.slug}`),
      ])
      const countryData = countryResponse.data.data
      this.country = {
        name: countryData.name || '',
        draftId: countryData.draftId,
        draft: countryData.draft ? {
          slug: countryData.draft.slug || this.$route.params.slug,
          summary: countryData.draft.summary || '',
          fxRegime: countryData.draft.fxRegime || '',
        } : null,
      }
    } catch (error) {
      this.$router.push('/countries')
    }
  }

  async saveDraft(notify = false) {
    const id = this.country.draftId
    try {
      const responsePromise = gateway.post(`cms/engage/country/drafts/${id}/revisions`, this.country.draft)
      await responsePromise

      if (notify) {
        this.$notify(successNotification(`Your recent changes for ${this.country.name} were saved as draft.`))
      }
    } catch (error) {
      this.$notify(warningNotification('Insufficient permissions.'))
    }
  }

  onCancel() {
    this.$router.push('/countries')
  }

  onSave(data) {
    this.country.draft = {
      ...this.country.draft,
      ...data
    }
    this.delayedSave()
  }

  async onPublish(data) {
    this.country.draft = {
      ...this.country.draft,
      ...data
    }
    await this.saveDraft()

    const id = this.country.draftId
    try {
      const responsePromise = gateway.post(`cms/engage/country/drafts/${id}/publish`, {})

      await responsePromise
      this.$notify(successNotification(`Your changes for ${this.country.name} have been published.`))
    } catch (error) {
      this.$notify(warningNotification('Insufficient permissions.'))
    }
  }
}
</script>
